import React from 'react'
import { connect } from 'react-redux'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { Page } from '../../../components/page/Page'
import { routes } from '../../../constants'
import utils from '../../../utils/index'
import { actions } from '../bandeira.actions'
import { BandeiraForm } from './BandeiraForm'
import _ from 'lodash'
import '../../../index.scss'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  const record = state.crudBandeiraState.currentRecord
  return {
    colunasTaxas: state.crudBandeiraState.colunasTaxas,
    messages: state.crudBandeiraState.messages,
    record,
    first: state.crudBandeiraState.index,
    rows: state.crudBandeiraState.max,
    totalRecords: state.crudBandeiraState.count,
    sortField: state.crudBandeiraState.sortField,
    order: state.crudBandeiraState.sortOrder,
    selectedFilters: state.crudBandeiraState.selectedFilters,
    taxa: state.crudBandeiraState.taxa,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadById: (oid) => dispatch(actions.loadById(oid)),
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    setField: (field, value) => dispatch(actions.setField(field, value)),
    setTaxa: (prop, value) => dispatch(actions.setTaxa(prop, value)),
    addTaxa: (payload) => dispatch(actions.addTaxa(payload)),
    onClickRemoveTaxa: (taxa) => dispatch(actions.onClickRemoveTaxa(taxa)),
    showWarningMessage: (message) => dispatch(actions.showWarningMessage(message)),
  }
}

class BandeiraFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.dataTableItens = React.createRef()
    this.state = {
      selectedItens: [],
      activeIndex: 0,
      showDialogRemove: false,
    }
    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_BANDEIRA}/${oid}`)
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_BANDEIRA}/novo`)
    }
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_BANDEIRA}`)
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_BANDEIRA}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  onSelectionChange = (e) => {
    this.setState({ selectedItens: e.value })
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  changeActiveIndex = (index) => {
    this.setState({ activeIndex: index })
  }

  formatColumn = (rowData, column) => {
    return utils.format(rowData, column)
  }

  hasOverlap = (taxas) => {
    if (!taxas || taxas.length < 2) return false

    // Ordena pelo início do intervalo
    taxas.sort((a, b) => a.parcelaInicial - b.parcelaInicial)

    for (let i = 0; i < taxas.length - 1; i++) {
      const atual = taxas[i]
      const proxima = taxas[i + 1]

      // Se o final do atual >= início do próximo, há sobreposição
      if (atual.parcelaFinal >= proxima.parcelaInicial) {
        return true
      }
    }
    return false
  }

  onAddTaxa = (taxa) => {
    if (taxa.parcelaInicial > taxa.parcelaFinal) {
      this.props.showWarningMessage('A parcela inicial não pode ser maior que a parcela final.')
      return
    }
    const temp = _.cloneDeep(this.props.record.taxas || [])
    temp.push(taxa)
    const overlap = this.hasOverlap(temp)
    if (overlap) {
      this.props.showWarningMessage('As taxas não podem se sobrepor.')
      return
    }
    this.props.addTaxa(taxa)
  }

  render() {
    const content = (
      <div>
        <BandeiraForm
          selection={this.state.selectedItens}
          onSelectionChange={this.onSelectionChange}
          record={this.props.record}
          onRowSelect={this.onRowSelect}
          messages={this.props.messages}
          state={this.state}
          changeActiveIndex={this.changeActiveIndex}
          taxa={this.props.taxa}
          setField={this.props.setField}
          addTaxa={this.onAddTaxa}
          setTaxa={this.props.setTaxa}
          onClickRemoveTaxa={this.props.onClickRemoveTaxa}
        />
      </div>
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BandeiraFormPageContainer)
